/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query BusinessoverviewQuery($uid: String!) {
    prismic {
      businessoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_BusinessoverviewBodyHerovideo {
          type
            label
            primary {
              fullscreen
              large_text
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              hero_video_color_overlay
              hero_video_placeholder_img
              hero_video_url {
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              subheading
              subheading_color
              text_color
              video_icon
              video_timestamp
              video_timestamp_color
              video_title
              video_title_color
              video_wistia_id
            }
        },
        ... on PRISMIC_BusinessoverviewBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_BusinessoverviewBodyQuotescarousel {
          type
            label
            fields {
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              logo
              name_and_position
              photo
              quote
            }
            primary {
              background_image
            }
        },
        ... on PRISMIC_BusinessoverviewBodyCardshoverlinks {
          type
            label
            fields {
              card_icon
              card_text
              card_title
              link_1 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_1_text
              link_2 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_2_text
              link_3 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_3_text
              link_4 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_4_text
              link_only_card
            }
            primary {
              background_color
              subtitle
              title1
              background_image
            }
        },
        ... on PRISMIC_BusinessoverviewBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_BusinessoverviewBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Businessoverview = ({ data, location }) =>
  data.prismic.businessoverview ? (
    <MainLayout location={location} layout='businessoverview'>
    <Helmet>
      <title>{(data.prismic.businessoverview.title[0] && data.prismic.businessoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href='https://www.digitalocean.com/' />
      <meta
        name="description"
        content={
          data.prismic.businessoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.businessoverview.title[0] ? data.prismic.businessoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.businessoverview.description ? data.prismic.businessoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.businessoverview.open_graph_image ? data.prismic.businessoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.businessoverview.description ? data.prismic.businessoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.businessoverview.title[0] ? data.prismic.businessoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.businessoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.businessoverview.path : 'https://www.digitalocean.com' + data.prismic.businessoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.businessoverview.open_graph_image ? data.prismic.businessoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.businessoverview.body} />
    </MainLayout>
  ) : null;

Businessoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Businessoverview;
